import { render, staticRenderFns } from "./transiciones.vue?vue&type=template&id=dfbb99fe&"
import script from "./transiciones.component.ts?vue&type=script&lang=ts&"
export * from "./transiciones.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports